import { FunctionComponent } from 'react';

import { FileShortSummary } from '@savgroup-front-common/types';
import { FileStateHistorySummary } from '@/api/Workflow/getFileStatesQuery';

import FileProgress from './FileProgress/FileProgress';
import { $Card, $CardContent, $Divider } from './MultiProductInfo.styles';
import MultiProductInfoDescription from './MultiProductInfoDescription/MultiProductInfoDescription';
import ProductInfoHeader from './ProductInfoHeader/ProductInfoHeader';

interface MultiProductInfoProps {
  file: FileShortSummary;
  histories?: FileStateHistorySummary[];
  onClick: () => void;
}

export const MultiProductInfo: FunctionComponent<MultiProductInfoProps> = ({
  file,
  histories,
  onClick,
}) => {
  return (
    <$Card minimal elevation={2} onClick={onClick} isCliquable={!!onClick}>
      <ProductInfoHeader file={file} />
      <$Divider />
      <$CardContent>
        <MultiProductInfoDescription file={file} />
        {!!histories && <FileProgress histories={histories} />}
      </$CardContent>
    </$Card>
  );
};

MultiProductInfo.displayName = 'MultiProductInfo';
